var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 50,
    viewBox: "0 0 54 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.1141 0.428148C52.5429 -0.142716 51.6194 -0.142716 51.049 0.428148L24.5611 26.9299L17.2521 19.6164C16.6816 19.0459 15.7573 19.0459 15.1869 19.6176C14.6164 20.1881 14.6164 21.1132 15.1869 21.684L23.5291 30.03C23.8141 30.3154 24.1872 30.4591 24.5611 30.4591C24.9354 30.4591 25.3085 30.3162 25.5935 30.03L53.1141 2.49374C53.6846 1.92288 53.6846 0.997784 53.1141 0.428148Z",
    fill: "#F9DEB1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6842_2798",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 4,
    width: 46,
    height: 46
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.39648H45.4975V50.0001H0V4.39648Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6842_2798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.2397 18.4049C41.4829 18.6846 41.0972 19.5258 41.3761 20.283C42.1889 22.4796 42.6005 24.7938 42.6005 27.16C42.6005 38.0932 33.7112 46.9875 22.7841 46.9875C11.8574 46.9875 2.96885 38.0932 2.96885 27.16C2.96885 16.2271 11.8582 7.33246 22.7853 7.33246C26.8628 7.33246 30.7786 8.56182 34.1092 10.8871C34.771 11.349 35.6813 11.1868 36.1425 10.5246C36.6044 9.86203 36.4418 8.95127 35.7809 8.48934C31.958 5.82053 27.4648 4.41016 22.7861 4.41016C10.2476 4.41016 0.0473633 14.6153 0.0473633 27.16C0.0473633 39.7047 10.2476 49.9102 22.7853 49.9102C35.3226 49.9102 45.5232 39.7047 45.5232 27.16C45.5232 24.4465 45.0498 21.7924 44.1169 19.2682C43.8364 18.5114 42.9977 18.1256 42.2397 18.4049Z",
    fill: "#F9DEB1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check_icon.7de2a9336353b9e0f02775a773621294.svg";
export { ForwardRef as ReactComponent };